/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Learn_Mistakestypeenglishwordspelling4Inputs */

const zh_learn_mistakestypeenglishwordspelling4 = /** @type {(inputs: Learn_Mistakestypeenglishwordspelling4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`英语拼写`)
};

const en_learn_mistakestypeenglishwordspelling4 = /** @type {(inputs: Learn_Mistakestypeenglishwordspelling4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`English Spelling`)
};

const es_learn_mistakestypeenglishwordspelling4 = /** @type {(inputs: Learn_Mistakestypeenglishwordspelling4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ortografía inglesa`)
};

/**
* | output |
* | --- |
* | "English Spelling" |
*
* @param {Learn_Mistakestypeenglishwordspelling4Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const learn_mistakestypeenglishwordspelling4 = /** @type {((inputs?: Learn_Mistakestypeenglishwordspelling4Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Learn_Mistakestypeenglishwordspelling4Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_learn_mistakestypeenglishwordspelling4(inputs)
	if (locale === "en") return en_learn_mistakestypeenglishwordspelling4(inputs)
	return es_learn_mistakestypeenglishwordspelling4(inputs)
});
export { learn_mistakestypeenglishwordspelling4 as "learn_mistakesTypeEnglishWordSpelling" }